<template>
  <div class="mypage-ec-site-connect-section">
    <mypage-ec-site-connect-complete-parts
      v-if="ecConnectStatus === 'connected' || isConnectedBrowsingThisPage"
    />
    <p class="mypage-ec-site-connect-section__prepare" v-else>
      {{ $tc('MypagePage.MypageEcSiteConnectPage.prepareMessage') }}
    </p>
    <atom-icon-link-button
      v-if="ecConnectStatus !== 'connected' && !isConnectedBrowsingThisPage"
      class="mypage-ec-site-connect-section__link"
      :url="ecSiteRegistrationUrl"
      :linkText="$tc('MypagePage.MypageEcSiteConnectPage.ecSiteRegisterLinkLabel')"
      :colorType="'secondary'"
      :imgPath="require('@/assets/img/icon/icon_external_link_gray.svg')"
      :iconPosition="'right'"
    />
    <mypage-ec-site-connect-button-parts
      v-if="ecConnectStatus !== 'connected' && !isConnectedBrowsingThisPage"
      class="mypage-ec-site-connect-section__button"
      :ecConnectStatus="ecConnectStatus"
      @connectEc="connectEc"
    />
    <atom-icon-link-button
      v-if="
        ecConnectStatus === 'connecting' ||
        ecConnectStatus === 'connected' ||
        isConnectedBrowsingThisPage
      "
      class="mypage-ec-site-connect-section__link"
      :url="ecSiteUrl"
      :linkText="$tc('MypagePage.MypageEcSiteConnectPage.ecSiteLinkLabel')"
      :imgPath="require('@/assets/img/icon/icon_external_link_gray.svg')"
      :colorType="'tertiary'"
    />
    <mypage-ec-site-connect-error-parts
      v-if="isEcConnectError"
      class="mypage-ec-site-connect-section__error"
      :errorData="ecConnectErrorData"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref } from '@vue/composition-api'
import MypageEcSiteConnectErrorParts from '@/components/MypageEcSiteConnectPage/MypageEcSitePane/parts/MypageEcSiteConnectErrorParts.vue'
import MypageEcSiteConnectCompleteParts from '@/components/MypageEcSiteConnectPage/MypageEcSitePane/parts/MypageEcSiteConnectCompleteParts.vue'
import AtomIconLinkButton from '@/components/atoms/AtomIconLinkButton.vue'
import MypageEcSiteConnectButtonParts from '@/components/MypageEcSiteConnectPage/MypageEcSitePane/parts/MypageEcSiteConnectButtonParts.vue'
import StoreUtil from '@/store/StoreUtil'
import type { EcConnectStatusType } from '@/store/stores/pageStore/MypagePage/MypagePageStore'
import Const from '@/util/Const'
import useEcErrorHandling from '@/components/MypageEcSiteConnectPage/hook/useEcErrorHandling'

export default defineComponent({
  name: 'MypageEcSiteConnectSection',
  components: {
    MypageEcSiteConnectButtonParts,
    AtomIconLinkButton,
    MypageEcSiteConnectCompleteParts,
    MypageEcSiteConnectErrorParts,
  },
  props: {
    isConnectedBrowsingThisPage: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const mypagePageStore = StoreUtil.useStore('MypagePageStore')
    const { ecConnectStatus, isEcConnectError } = mypagePageStore
    const { ecConnectErrorData } = useEcErrorHandling()

    // ECサイト会員登録ページURL
    const ecSiteRegistrationUrl = Const.EXTERNAL_LINKS.EC_SITE.REGISTRATION
    // ECサイトメインページURL
    const ecSiteUrl = Const.EXTERNAL_LINKS.EC_SITE.TOP

    return {
      // MypageEcSiteConnectSection
      ecSiteRegistrationUrl,
      ecSiteUrl,
      // useEcErrorHandling
      ecConnectErrorData,
      // MypagePageStore
      ecConnectStatus: ecConnectStatus as Ref<EcConnectStatusType>,
      isEcConnectError: isEcConnectError as Ref<boolean>,
    }
  },
  methods: {
    connectEc() {
      this.$emit('connectEc')
    },
  },
})
</script>

<style scoped lang="scss">
.mypage-ec-site-connect-section {
  color: $gray75;
  text-align: center;

  &__prepare {
    font-size: 13px;
    white-space: pre-wrap;
  }

  &__link {
    max-width: 347px;
    margin: 12px auto 0;

    ::v-deep {
      img {
        width: 12px;
        height: 12px;
      }
    }
  }

  &__button {
    margin-top: 24px;
  }

  &__error {
    margin-top: 12px;
  }
}
</style>
